import { UseQueryOptions, keepPreviousData, useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

import {
  GetStatServiceGameGroupsRequestDto,
  GetStatServiceRoomsDataResponseDto,
} from "@/shared/api";
import { useApi } from "@/shared/api/use-api";

export const useStatGameGroups = (rooms: string[]) => {
  const { statsControllerApi } = useApi();
  return useQuery({
    queryKey: [`/stat-groups/fetch-game-groups`, rooms],
    queryFn: ({ signal }) => {
      return statsControllerApi.getGameGroups({ rooms }, { signal });
    },
    placeholderData: keepPreviousData,
    enabled: !!rooms.length,
  });
};
